import { TableBarOutlined } from "@mui/icons-material"
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material"

export const TablaAyudAcad: React.FC = () =>{
    return(
        <Box marginTop={5}>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow sx={{ backgroundColor: "#243165" }}>
                            <TableCell sx={{ color: "#FFFFFF", fontWeight: "bold" }}>Unidad que la planifica</TableCell>
                            <TableCell sx={{ color: "#FFFFFF", fontWeight: "bold" }}>Código</TableCell>
                            <TableCell sx={{ color: "#FFFFFF", fontWeight: "bold" }}>Componente</TableCell>
                            <TableCell sx={{ color: "#FFFFFF", fontWeight: "bold" }}>Nombre</TableCell>
                            <TableCell sx={{ color: "#FFFFFF", fontWeight: "bold" }}># de plazas planificadas</TableCell>
                            <TableCell sx={{ color: "#FFFFFF", fontWeight: "bold" }}># horas por plaza planificada</TableCell>
                            <TableCell sx={{ color: "#FFFFFF", fontWeight: "bold" }}>Horas totales</TableCell>
                        </TableRow>

                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell>FIEC</TableCell>
                            <TableCell>0001</TableCell>
                            <TableCell>Práctico</TableCell>
                            <TableCell>Fundamentos de programación</TableCell>
                            <TableCell>2</TableCell>
                            <TableCell>5</TableCell>
                            <TableCell>10</TableCell>
                        </TableRow> 
                        <TableRow>
                            <TableCell>FIEC</TableCell>
                            <TableCell>0001</TableCell>
                            <TableCell>Práctico</TableCell>
                            <TableCell>Fundamentos de programación</TableCell>
                            <TableCell>2</TableCell>
                            <TableCell>5</TableCell>
                            <TableCell>10</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>FIEC</TableCell>
                            <TableCell>0001</TableCell>
                            <TableCell>Práctico</TableCell>
                            <TableCell>Fundamentos de programación</TableCell>
                            <TableCell>2</TableCell>
                            <TableCell>5</TableCell>
                            <TableCell>10</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>FIEC</TableCell>
                            <TableCell>0001</TableCell>
                            <TableCell>Práctico</TableCell>
                            <TableCell>Fundamentos de programación</TableCell>
                            <TableCell>2</TableCell>
                            <TableCell>5</TableCell>
                            <TableCell>10</TableCell>
                        </TableRow>                       
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>

    )
}